import { API_ROUTES } from 'constants/CommonApi';
import UtilService from 'services/util';
import { isEmpty } from 'util/utils';

export const getSellerList = (request = {}, config) =>
  UtilService.callApiAsync({ ...API_ROUTES.Seller.paginate, request, ...(!isEmpty(config) && { config }) });
